import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoadingController, ToastController } from "ionic-angular";

/*
  Generated class for the ScreenScreenProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ScreenScreenProvider {
    private loader;
    constructor(
        private toastCtrl: ToastController,
        private loadingCtrl: LoadingController
    ) {}

    presentToast(message, duration = 3000) {
        let toast = this.toastCtrl.create({
            message,
            duration,
            position: "top",
        });
        toast.present();
    }

    presentLoading() {
        this.loader = this.loadingCtrl.create({
            content: "Aguarde...",
            spinner: "crescent",
            enableBackdropDismiss: false,
            dismissOnPageChange: true,
        });
        this.loader.present();
    }

    dismissLoading() {
        this.loader.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/providers/screen-screen/screen-screen.ts